import axios from 'axios'
import { getToken } from './../services-jwt'
import store from './../../store'

// Use relative URL when proxy is enabled
const baseURL = process.env.VUE_APP_USE_PROXY === 'true' 
  ? '' 
  : process.env.VUE_APP_BASE_URL_EXTERNAL;

const HTTP = axios.create({
    baseURL : baseURL,
    headers : {
        'Content-Type' : 'application/json',
        Accept : 'application/json'
    }
})

const stripContentTypeForFormData = (req) => {
    if (!req || !req.data || typeof FormData === 'undefined') {
        return req
    }
    if (req.data instanceof FormData) {
        if (req.headers && typeof req.headers.delete === 'function') {
            req.headers.delete('Content-Type')
        } else if (req.headers) {
            delete req.headers['Content-Type']
            delete req.headers['content-type']
        }
    }
    return req
}

HTTP.interceptors.request.use(
    function (req) {
        const token = getToken()
        if (token) {
            const authHeader = `Token ${token}`
            if (req.headers && typeof req.headers.set === 'function') {
                req.headers.set('Authorization', authHeader)
            } else {
                req.headers = req.headers || {}
                req.headers.Authorization = authHeader
            }
        }
        req = stripContentTypeForFormData(req)
        return req
    },
    function (err) {
        return Promise.reject(err)
    }
)

// Response interceptor to handle 401 errors globally
HTTP.interceptors.response.use(
    function (response) {
        // If response is successful, just return it
        return response
    },
    function (error) {
        // If we get a 401 Unauthorized error, clear auth and cache
        if (error.response && error.response.status === 401) {
            store.commit('auth/CLEAR_AUTH_USER', null)
            store.commit('clients/CLEAR_REFERENCE_DATA_CACHE')
            window.Bus.emit('logout')
        }
        return Promise.reject(error)
    }
)

export default HTTP
